import en from './locales/en.json';
import uk from './locales/uk.json';
import pl from './locales/pl.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import es from './locales/es.json';

export const DICTS = { en, uk, pl, de, fr, it, es };

export const LOCALE_OPTIONS = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'uk', label: 'Українська', short: 'UA' },
  { code: 'pl', label: 'Polski', short: 'PL' },
  { code: 'de', label: 'Deutsch', short: 'DE' },
  { code: 'fr', label: 'Français', short: 'FR' },
  { code: 'it', label: 'Italiano', short: 'IT' },
  { code: 'es', label: 'Español', short: 'ES' },
];

export const STORAGE_KEY = 'wedding-platform-locale';

const LOCALE_ALIASES = { ua: 'uk' };

function normalizeLocale(raw) {
  const base = String(raw || '').trim().toLowerCase().split(/[-_]/)[0];
  const code = LOCALE_ALIASES[base] || base;
  return DICTS[code] ? code : null;
}

/** `?lang=pl` (e.g. from an ad link) wins over a stored choice and is remembered. */
function localeFromUrl() {
  if (typeof window === 'undefined') return null;
  try {
    return normalizeLocale(new URLSearchParams(window.location.search).get('lang'));
  } catch (_) {
    return null;
  }
}

export function detectInitialLocale() {
  const fromUrl = localeFromUrl();
  if (fromUrl) {
    try {
      localStorage.setItem(STORAGE_KEY, fromUrl);
    } catch (_) {
      /* ignore */
    }
    return fromUrl;
  }
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && DICTS[stored]) return stored;
  } catch (_) {
    /* ignore */
  }
  if (typeof navigator === 'undefined') return 'en';
  const list = navigator.languages?.length ? navigator.languages : [navigator.language || 'en'];
  for (const raw of list) {
    const base = String(raw).toLowerCase().split('-')[0];
    if (DICTS[base]) return base;
  }
  return 'en';
}
